import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { toast } from "sonner";
import { useCurrentUser } from "@/features/login/hooks/useCurrentUser";
import { axiosInstance } from "@retro-ia/shared/axios";

export const useLogout = () => {
  const navigate = useNavigate();
  const { logout: clearUser } = useCurrentUser();

  return useMutation({
    mutationFn: async () => {
      await axiosInstance.post("/auth/logout", {}, { withCredentials: true });
    },
    onSuccess: () => {
      clearUser();
      toast.success("Has cerrado sesión correctamente.");
      navigate("/");
    },
    onError: () => {
      // Interceptor may have already cleared the session (403/401).
      // Force client-side cleanup and redirect regardless.
      clearUser();
      navigate("/");
    },
  });
};
